<template>
<div>
  <div class="top" v-if="isFree == '是'">
    <div class="gametitle">
      {{ $t(`lang.str_symbol`) }}
    </div>
  </div>
  <div class="gameImgArea_2" v-if="isFree == '是'">
    <div class="box">
      <img :src="require('../../assets/hjzs/' + symbol1 + '.png')" alt=""
           :class="{ deep: true }">
    </div>
    <div class="box" v-if="extra">
      <img :src="require('../../assets/hjzs/' + symbol2 + '.png')" alt=""
           :class="{ deep: true }">
    </div>
  </div>
  <SlotsMapTwoLayout
    :mapList ="mapList"
    :mapListDetail ="mapListDetail"
    :mapIndex="mapIndex"
    :subMapList ="subMapList"
    :subMapListDetail ="subMapListDetail"
    :subMapIndex="subMapIndex"
    :lang="lang"
    :phone = "phone"
    :winValueTotal = "winValueTotal"
    :check-scatter-win=true
    scatter-win="scatterwin"
    scatter-item="S"
    :show-top=true
    :show-total=true
    game-path="hjzs"/>
</div>
</template>

<script>
import SlotsWinTotalLayout from "./layout/slots_win_total_layout.vue";
import GameTitleLayout from "../common/game_detail_title.vue";
import SlotsMapTwoLayout from "./layout/slots_map_two_layout.vue";

export default {
  name: "Game5005",
  components: {
    SlotsMapTwoLayout,
    SlotsWinTotalLayout,
    GameTitleLayout

  },
  props: {
    showTop: false,
    showTotal:false,
    winValueTotal:"",
    lang:"",
    Phone:false,
    mapList: [],
    mapListDetail: [],
    mapIndex: [],
    subMapList: [],
    subMapListDetail:[],
    subMapIndex:[],
    isFree:false,
    extra:false,
    symbol1:0,
    symbol2:0,
  }
}
</script>
<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/slots/game_5005.vue